import { fetchToken } from "../../../common/FetchCookie";

const API = "https://api.indiahirings.com/api/profile/check-mobile-number"


export const PhoneVerify = async (number) => {
  try {
    const token = await fetchToken(); // Ensure this function is correct
    const response = await fetch(`${API}`, {
      method: "POST",
      body: JSON.stringify({ number }), // Corrected body format
      headers: {
        "Content-Type": "application/json", // Added proper header
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      const errorData = await response.json(); // Parse error response
      throw new Error(errorData.message || "Failed to send email");
    }

    return response.json(); // Directly return parsed JSON
  } catch (error) {
    throw new Error(error.message);
  }
};


export const CheckPhoneVerify = async (mobile) => {
  try {
    const token = await fetchToken(); // Ensure this function is correct
    const response = await fetch(`${API}`, {
      method: "POST",
      body: JSON.stringify({ mobile }), // Corrected body format
      headers: {
        "Content-Type": "application/json", // Added proper header
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      const errorData = await response.json(); // Parse error response
      throw new Error(errorData.message || "Failed to send email");
    }

    return response.json(); // Directly return parsed JSON
  } catch (error) {
    throw new Error(error.message);
  }
};
